import {BookCommon, IFileData, IHistoryBook, IInfoIdFileData} from "../models/Book";

const poleNames = ["year" , "title" , 'name' , 'author_name'];
const sortTypes = ["asc" , "desc"];

export function isHistoryBook(book:BookCommon): book is IHistoryBook {
    if("issueDate" in book)
    {
        return true;
    }
    return  false;
}

export function isInfoFileData(fileData:IFileData): fileData is IInfoIdFileData {
    if("pln" in fileData)
    {
        return true;
    }
    return  false;
}

export const isPoleName = (poleName:string): poleName is "year" | "title" | 'name' | 'author_name' => {
    return poleNames.includes(poleName);
}

export const isSortType = (sortType:string):sortType is "asc" | "desc" => {
    return sortTypes.includes(sortType);
}